import { render } from "./AdminRateList.vue?vue&type=template&id=08f8066e&scoped=true&ts=true"
import script from "./AdminRateList.vue?vue&type=script&lang=ts"
export * from "./AdminRateList.vue?vue&type=script&lang=ts"

import "./AdminRateList.vue?vue&type=style&index=0&id=08f8066e&scoped=true&lang=css"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08f8066e"]])

export default __exports__